import { render, staticRenderFns } from "./BodyInfoForm.vue?vue&type=template&id=0e4ae856&scoped=true"
import script from "./BodyInfoForm.vue?vue&type=script&lang=js"
export * from "./BodyInfoForm.vue?vue&type=script&lang=js"
import style0 from "./BodyInfoForm.vue?vue&type=style&index=0&id=0e4ae856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4ae856",
  null
  
)

export default component.exports